import { Expose } from "class-transformer";
import { IsNotEmpty, IsNumber, Min } from "class-validator";

export class CreateLeadRankConfigInput {
  @Expose()
  @IsNumber()
  @IsNotEmpty()
  @Min(0, { message: "Lead rank threshold must be a positive number" })
  leadRankThreshold: number;
}
